<template lang="pug">
fieldset(:disabled="comunicadoLoading")
  form(@submit.prevent="onSubmit")
    .container.grid-lg
      .toast.toast-warning
        b Atenção
        p Este comunicado vai enviar uma mensagem para cada usuário interno da prefeitura
      .columns
        .column.col-9.col-sm-12
          form-group(
            :label="'mensagem.titulo' | tModel"
            :validation="$v.form.titulo"
          )
          .input-group(style="margin-top: -8px")
            span.input-group-addon Comunicado interno:
            input.form-input(v-model="$v.form.titulo.$model")

        .column.col-3.col-sm-12
          form-group(
            :label='"mensagem.prioridade" | tModel',
            :validation='$v.form.prioridade'
          )
            select.form-select(v-model="$v.form.prioridade.$model")
              option(:value="4") Baixa
              option(:value="3") Média
              option(:value="2") Alta
              option(:value="1") Máxima
        .column.col-12
          form-group(
            :label='"mensagem.conteudo" | tModel'
            :validation="$v.form.conteudo"
          )
            textarea.form-input(v-model="$v.form.conteudo.$model")
      .columns.my-2(v-if="form.anexos.length")
        .column.col-auto(v-for="anexo in form.anexos")
          .anexo(:style="{backgroundImage: `url(${anexo.file_info.thumb}`}")
            a.button-remove.text-error(@click="onRemoveAnexo(anexo)")
              i.fa.fa-trash
      modal-anexos(ref="modalAnexos" @saveAnexos='onSaveAnexos' title="Anexos do comunicado")
      a.btn.btn-link(@click='() => $refs.modalAnexos.open(form.anexos || [])')
        btn-content(icon="fa fa-paperclip" label='Anexos')
      .text-right
        button.btn.btn-primary(:disabled="$v.form.$invalid" :class="{loading: comunicadoLoading}")
          btn-content(name="send")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import { required, minLength } from 'vuelidate/lib/validators'

const INITIAL_FORM = () => ({
  prioridade: 3,
  titulo: '',
  conteudo: '',
  anexos: [],
})

export default {
  vuex: {
    'mensagens/enviadas': {
      actions: ['fetchComunicar'],
      state: ['comunicadoLoading'],
    },
  },
  data() {
    return {
      form: INITIAL_FORM(),
    }
  },
  validations: {
    form: {
      prioridade: { required },
      titulo: { required },
      conteudo: { required, minLength: minLength(10) },
    },
  },
  methods: {
    onSaveAnexos(anexos) {
      this.form.anexos = anexos
    },
    onRemoveAnexo(anexo) {
      this.form.anexos = this.form.anexos.filter(
        ({ file_info: { id } }) => id !== anexo.file_info.id,
      )
    },
    async onSubmit() {
      try {
        await this.fetchComunicar(this.form)
        this.$toaster.success('Comunicado enviado com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.anexo
  width 80px
  background-color #eee
  height 80px
  position relative
  background-size contain
  background-repeat no-repeat
  border-radius 10px

.button-remove
  display flex
  align-items center
  justify-content center
  border 1px solid #DA0808
  text-decoration none
  width 20px
  height 20px
  font-size .6rem
  cursor pointer
  background-color #eee
  border-radius 50%
  position absolute
  right -4px
  top -4px
</style>
